const UPDATES = [
  {
    date: '08-01',
    title: '《流浪地球3》4K蓝光版已上线',
    tag: '新片',
    description: '国产科幻巨制第三部，4K蓝光画质呈现震撼视效。',
  },
  {
    date: '07-31',
    title: '经典港片修复计划 — 《英雄本色》系列全集上线',
    tag: '修复',
    description: '周润发、张国荣经典之作，4K修复画质重温港片辉煌。',
  },
  {
    date: '07-30',
    title: '暑期动漫特辑 — 50部高分动漫合集已更新',
    tag: '合集',
    description: '从经典到新番，暑假必看动漫清单一次满足。',
  },
  {
    date: '07-29',
    title: '悬疑推理季 — 《隐秘的角落》团队新作上线',
    tag: '新剧',
    description: '迷雾剧场最新力作，烧脑剧情全程高能无尿点。',
  },
  {
    date: '07-28',
    title: '纪录片专区新增 — BBC《蓝色星球》全系列',
    tag: '纪录',
    description: '自然纪录片巅峰之作，4K超清呈现海底奇观。',
  },
  {
    date: '07-27',
    title: '播放线路优化升级 — 全站加载速度提升40%',
    tag: '系统',
    description: '多条高速线路扩容，观影体验更流畅不缓冲。',
  },
  {
    date: '07-26',
    title: '用户推荐片单功能上线 — 发现更多好片',
    tag: '功能',
    description: '基于观影偏好智能推荐，帮你找到下一部想看的。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">更新快讯</h2>
            <p className="mt-2 text-sm text-foreground-500">最新上架与平台动态，每日更新不停歇</p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="relative pl-8 border-l-2 border-primary-200">
              {UPDATES.map((item, i) => (
                <div key={i} className={`relative pb-8 ${i === UPDATES.length - 1 ? 'pb-0' : ''}`}>
                  <div className="absolute -left-[29px] top-0 w-4 h-4 rounded-full bg-primary-500 border-4 border-background-100"></div>
                  <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                    <span className="whitespace-nowrap text-xs font-medium text-foreground-400 bg-background-200 px-2 py-0.5 rounded">
                      {item.date}
                    </span>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700">
                          {item.tag}
                        </span>
                        <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                      </div>
                      <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}